<bw-panel [ngClass]="{'registration-panel': registrationPage}">
  <section>
    <router-outlet></router-outlet>
  </section>
</bw-panel>

